import React from 'react';
import { Datagrid, TopToolbar, CreateButton, ExportButton, DatagridProps } from 'react-admin';
import { Typography, Box } from '@mui/material';

interface DataGridExtendedProps extends DatagridProps {
  title: string; // Title prop
  children: React.ReactNode; // Children prop to accept child elements
}

const CustomListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

const DataGridExtended: React.FC<DataGridExtendedProps> = ({ title, children, ...props }) => {
  return (
    <>
      {/* Custom header with title and toolbar */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2} // Adds margin-bottom to separate from the table
      >
        {/* Title */}
        <Typography variant="h5" sx={{ marginLeft: '16px', color:'#1976d2' }}>{title}</Typography>

        {/* Toolbar with Create and Export buttons */}
        <CustomListActions />
      </Box>

      {/* Datagrid with dynamic children and forwarded props */}
      <Datagrid {...props}>
        {children} {/* Render the passed children */}
      </Datagrid>
    </>
  );
};

export default DataGridExtended;